import { usersData } from './usersData.js'
import { Users } from '../data/users'
import { ENDPOINT, SIGNATURE_TYPE } from '../../constants/endpoint.js'
import axios from 'axios'
import Swal from 'sweetalert2'

var configWithToken = {
 headers: {
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
 },
}

const state = {
 users: null,
 user: null,
 error: null,
 portName: null,
 toolType: null,
 usageType: null,
 vesselType: null,
 status: null,
 zone: null,
 signatureName: null,
 teams: null,
}

const mutations = {
 SET_SIGNATUR_NAME(state, payload) {
  state.signatureName = payload
 },
 SET_USERS: (state, payload) => {
  state.users = payload
 },
 SET_USER: (state, payload) => {
  state.user = payload
 },
 SET_USER_DETAIL: (state, id) => {
  const data = usersData
  const userInfo = data.filter((x) => x.id == id)
  state.users = userInfo
 },
 SET_EDIT_OWNER_USER: (state, payload) => {
  const data = usersData
  for (const i in data) {
   if (data[i].id == payload.id) {
    data[i].id = payload.id
    data[
     i
    ].fullName = `${payload.title} ${payload.firstName} ${payload.lastName}`
    data[i].cardId = payload.cardId
    data[i].homeNumber = payload.homeNumber
    data[i].moo = payload.moo
    data[i].province = payload.province
    data[i].district = payload.district
    data[i].subDistrict = payload.subDistrict
    data[i].alley = payload.alley
    data[i].road = payload.road
    data[i].zipCode = payload.zipCode
   }
  }
  state.users = data
  console.log('this is edit state :', state.users)
 },
 SET_EDIT_JURISTIC_USER: (state, payload) => {
  const data = usersData
  for (const i in data) {
   if (data[i].id == payload.id) {
    data[i].id = payload.id
    data[
     i
    ].fullName = `${payload.title} ${payload.firstName} ${payload.lastName}`
    data[i].cardId = payload.cardId
    data[i].homeNumber = payload.homeNumber
    data[i].moo = payload.moo
    data[i].province = payload.province
    data[i].district = payload.district
    data[i].subDistrict = payload.subDistrict
    data[i].alley = payload.alley
    data[i].road = payload.road
    data[i].zipCode = payload.zipCode
    data[i].operatorName = payload.operatorName
    data[i].juristicNumber = payload.juristicNumber
    data[i].establishmentName = payload.establishmentName
    data[i].phoneNumber = payload.phoneNumber
   }
  }

  state.users = data
  console.log('test juristic :', state.users)
 },
 SET_EDIT_ADMIN: (state, payload) => {
  const data = usersData
  for (const i in data) {
   if (data[i].id == payload.id) {
    data[i].id = payload.id
    data[i].fullName = payload.fullName
    data[i].position = payload.position
    data[i].county = payload.county
    data[i].affiliation = payload.affiliation
    data[i].phoneNumber = payload.phoneNumber
    data[i].email = payload.email
   }
  }

  state.users = data
  console.log('this :', payload)
 },
 SET_INSERT_OWNER_USER: (state, payload) => {
  const data = usersData
  data.push(payload)
  state.users = data
 },
 SET_INSERT_JURISTIC_USER: (state, payload) => {
  const data = usersData
  data.push(payload)
  state.users = data
  console.log('add users data :', state.users)
 },
 SET_INSERT_ADMIN: (state, payload) => {
  const data = usersData
  data.push(payload)
  state.users = data
  console.log('this is admin data :', state.users)
 },
 SET_DELETE_USER: (state, id) => {
  const data = usersData
  var index = data.map((x) => x.id).indexOf(id)
  data.splice(index, 1)

  state.users = data
 },
 SET_SEARCH_USERS: (state, payload) => {
  const data = Users
  const info = data.find((x) => x.cardNumber == payload)
  state.users = info
  console.log('this is data :', info)
 },
 ERROR: (state, error) => {
  state.error = error
 },
 SET_PORT_NAME(state, payload) {
  state.portName = payload
 },
 SET_TOOL_TYPE(state, payload) {
  state.toolType = payload
 },
 SET_USAGE_TYPE(state, payload) {
  state.usageType = payload
 },
 SET_VESSEL_TYPE(state, payload) {
  state.vesselType = payload
 },
 SET_STATUS(state, payload) {
  state.status = payload
 },
 SET_ZONE(state, payload) {
  state.zone = payload
 },
 SET_TEAMS: (state, payload) => {
  state.teams = payload
 },
}

const actions = {
 setUsers: ({ commit }) => {
  const data = usersData
  console.log('store data :', data)
  commit('SET_USERS', data)
 },
 setUserDetail: ({ commit }, id) => {
  commit('SET_USER_DETAIL', id)
 },
 setEditProfileSupervisor: ({ commit }, payload) => {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  console.log('this is payload ====> ', payload)
  const url = ENDPOINT.UPDATE_USER

  axios
   .put(url, payload, config)
   .then((res) => {
    console.log(res)
    Swal.fire({
     icon: 'success',
     title: 'แก้ไขเรียบร้อยแล้ว',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = `/settings/me/${payload.id}`
    })
   })
   .catch((error) => {
    console.log(error)
    Swal.fire({
     icon: 'warning',
     title: 'เกิดข้อผิดพลาด',
     text: 'กรุณากรอกข้อมูลให้ถูกต้อง',
     showConfirmButton: false,
    }).then(() => {
     window.location.href = `/settings/me/${payload.id}`
    })
   })
 },
 setEditOwnerUser: ({ commit }, payload) => {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  console.log('this is payload ====> ', payload)
  const url = ENDPOINT.UPDATE_USER

  axios
   .put(url, payload, config)
   .then((res) => {
    console.log(res)
    Swal.fire({
     icon: 'success',
     title: 'แก้ไขเรียบร้อยแล้ว',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = '/admin/ownerList'
    })
   })
   .catch((error) => {
    console.log(error)
    Swal.fire({
     icon: 'warning',
     title: 'เกิดข้อผิดพลาด',
     text: 'กรุณากรอกข้อมูลให้ถูกต้อง',
     showConfirmButton: false,
    }).then(() => {
     window.location.href = '/admin/ownerList'
    })
   })
 },
 setEditJuristicUser: ({ commit }, payload) => {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  console.log('this is payload ====> ', payload)
  const url = ENDPOINT.UPDATE_USER

  axios
   .put(url, payload, config)
   .then((res) => {
    console.log(res)
    Swal.fire({
     icon: 'success',
     title: 'แก้ไขเรียบร้อยแล้ว',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = '/admin/ownerList'
    })
   })
   .catch((error) => {
    console.log(error)
    Swal.fire({
     icon: 'warning',
     title: 'เกิดข้อผิดพลาด',
     text: 'กรุณากรอกข้อมูลให้ถูกต้อง',
     showConfirmButton: false,
    }).then(() => {
     window.location.href = '/admin/ownerList'
    })
   })
 },
 setEditSuperVisor({ commit }, payload) {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  console.log('this is payload ====> ', payload)
  const url = ENDPOINT.UPDATE_USER

  axios
   .put(url, payload, config)
   .then((res) => {
    console.log(res)
   })
   .catch((error) => {
    console.log(error)
   })
 },
 setEditAdmin: ({ commit }, payload) => {
  commit('SET_EDIT_ADMIN', payload)
 },
 setInsertOwnerUser: ({ commit }, payload) => {
  commit('SET_INSERT_OWNER_USER', payload)
 },
 setInsertJuristicUser: ({ commit }, payload) => {
  commit('SET_INSERT_JURISTIC_USER', payload)
 },
 setInsertAdmin: async ({ commit }, payload) => {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
   },
  }
  const url = ENDPOINT.CREATE_ADMIN
  await axios
   .post(url, { ...payload }, config)
   .then((res) => {
    console.log('res ', res)
    commit('SET_INSERT_ADMIN', res.data)
    commit('ERROR', null)
   })
   .catch((e) => {
    commit('SET_USER', null)
    commit('ERROR', e.response.data.statusCode)
   })
   .finally(() => {})
 },
 setInsertSuperVisor: async ({ commit }, payload) => {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
   },
  }
  const url = ENDPOINT.CREATE_SUPERVISOR
  await axios
   .post(url, { ...payload }, config)
   .then((res) => {
    console.log('res ', res)
    Swal.fire({
     icon: 'success',
     title: 'บันทึกเรียบร้อยแล้ว',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = '/admin/users'
     // this.$router.push("/users");
    })

    commit('SET_INSERT_ADMIN', res.data)
    commit('ERROR', null)
   })
   .catch((e) => {
    commit('ERROR', e.response.data.statusCode)
    if (e.response.data.statusCode == 500) {
     // 409
     Swal.fire({
      icon: 'error',
      title: 'ชื่อผู้ใช้งานซ้ำ',
      showConfirmButton: false,
      timer: 1500,
     })
    }
    commit('SET_USER', null)
   })
   .finally(() => {})
 },
 createObserver: async ({ commit }, payload) => {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
   },
  }
  const url = ENDPOINT.CREATE_OBSERVER
  await axios
   .post(url, { ...payload }, config)
   .then((res) => {
    console.log('res ', res)
    Swal.fire({
     icon: 'success',
     title: 'บันทึกเรียบร้อยแล้ว',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = '/admin/users'
     // this.$router.push("/users");
    })

    commit('SET_INSERT_ADMIN', res.data)
    commit('ERROR', null)
   })
   .catch((e) => {
    commit('ERROR', e.response.data.statusCode)
    if (e.response.data.statusCode == 500) {
     // 409
     Swal.fire({
      icon: 'error',
      title: 'ชื่อผู้ใช้งานซ้ำ',
      showConfirmButton: false,
      timer: 1500,
     })
    }
    commit('SET_USER', null)
   })
   .finally(() => {})
 },
 createContractor: async ({ commit }, payload) => {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    'Content-Type': 'application/json',
   },
  }
  const url = ENDPOINT.CREATE_CONTRACTOR
  await axios
   .post(url, { ...payload }, config)
   .then((res) => {
    console.log('res ', res)
    Swal.fire({
     icon: 'success',
     title: 'บันทึกเรียบร้อยแล้ว',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = '/admin/users'
     // this.$router.push("/users");
    })

    commit('SET_INSERT_ADMIN', res.data)
    commit('ERROR', null)
   })
   .catch((e) => {
    commit('ERROR', e.response.data.statusCode)
    if (e.response.data.statusCode == 500) {
     // 409
     Swal.fire({
      icon: 'error',
      title: 'ชื่อผู้ใช้งานซ้ำ',
      showConfirmButton: false,
      timer: 1500,
     })
    }
    commit('SET_USER', null)
   })
   .finally(() => {})
 },
 setDeleteUser: ({ commit }, id) => {
  commit('SET_DELETE_USER', id)
 },
 setSearchUsers({ commit }, cardNumber) {
  commit('SET_SEARCH_USERS', cardNumber)
 },
 async setUserById({ commit }, { cardNumber, id }) {
  const config = {
   params: {
    cardNumber,
    id,
   },
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  const url = ENDPOINT.GET_USER_BY_ID
  await axios
   .get(url, config)
   .then((res) => {
    console.log('res ', res)
    commit('SET_USER', res.data)
    commit('ERROR', null)
   })
   .catch((e) => {
    commit('SET_USER', null)
    commit('ERROR', e.response.data.statusCode)
   })
   .finally(() => {})
 },
 async getDataFromServer({ commit }, { isAdmin, isContractor, isOwnerList }) {
  const config = {
   // params: {
   //   cardNumber
   // },
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  let url
  if (isAdmin) {
   url = ENDPOINT.GET_USER_ADMIN
  } else {
   if (isContractor) {
    url = ENDPOINT.GET_CONTRACTOR
   } else {
    if (isOwnerList) {
     url = ENDPOINT.GET_OWNER
    } else {
     url = ENDPOINT.GET_USER_ALL
    }
   }
  }
  await axios
   .get(url, config)
   .then((res) => {
    console.log(res)
    commit('SET_USERS', res.data)
    commit('ERROR', null)
   })
   .catch((e) => {
    commit('SET_USER', null)
    commit('ERROR', e.response.data.statusCode)
   })
   .finally(() => {})
 },
 async getPortName({ commit }) {
  const url = ENDPOINT.GET_PORT_NAME
  await axios
   .get(url, null, configWithToken)
   .then((response) => {
    commit('SET_PORT_NAME', response.data)
    console.log('this is res :', response)
   })
   .catch((error) => {
    console.log(error)
   })
 },
 async getToolType({ commit }) {
  const url = ENDPOINT.GET_TOOL_TYPE
  await axios
   .get(url, null, configWithToken)
   .then((response) => {
    commit('SET_TOOL_TYPE', response.data)
   })
   .catch((error) => {
    console.log(error)
   })
 },
 async getUsageType({ commit }) {
  const url = ENDPOINT.GET_USAGE_TYPE
  await axios
   .get(url, null, configWithToken)
   .then((response) => {
    commit('SET_USAGE_TYPE', response.data)
   })
   .catch((error) => {
    console.log(error)
   })
 },
 async getVesselType({ commit }) {
  const url = ENDPOINT.GET_VESSEL_TYPE
  await axios
   .get(url, null, configWithToken)
   .then((response) => {
    commit('SET_VESSEL_TYPE', response.data)
   })
   .catch((error) => {
    console.log(error)
   })
 },
 async getZone({ commit }) {
  const url = ENDPOINT.GET_ZONE
  await axios
   .get(url, null, configWithToken)
   .then((response) => {
    commit('SET_ZONE', response.data)
   })
   .catch((error) => {
    console.log(error)
   })
 },
 async setInsertUser({ commit }, payload) {
  console.log('setInsertUser test payload ', payload)
  const formData = new FormData()
  formData.append('title', payload.title)
  formData.append('firstName', payload.firstName)
  formData.append('lastName', payload.lastName)
  formData.append('cardNumber', payload.cardNumber)
  formData.append('houseCodeNumber', payload.houseCodeNumber)
  formData.append('registrationOffice', payload.registrationOffice)
  formData.append('buildingName', payload.buildingName)
  formData.append('address', payload.address)
  formData.append('floor', payload.floor)
  formData.append('villageNumber', payload.villageNumber)
  formData.append('lane', payload.lane)
  formData.append('road', payload.road)
  formData.append('province', payload.province)
  formData.append('district', payload.district)
  formData.append('subDistrict', payload.subDistrict)
  formData.append('postalCode', payload.postalCode)
  formData.append('phoneNumber', payload.phoneNumber)
  formData.append('email', payload.email)
  formData.append('username', payload.username)
  formData.append('password', '12345678')
  formData.append('confirmPassword', '12345678')
  formData.append('personType', payload.personType)
  formData.append('files', payload.idCardImageFile)

  const config = {
   headers: {
    'content-type': 'multipart/form-data',
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  await axios
   .post(`${ENDPOINT.CREATE_USER}`, formData, config)
   .then((res) => {
    commit('SET_STATUS', 201)
    console.log('this is response :', res.data)
    Swal.fire({
     target: document.getElementById('popup-notify'),
     icon: 'success',
     title: 'บันทึกข้อมูลสำเร็จ',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = '/admin/users'
    })
   })
   .catch((error) => {
    if (error.response.data.statusCode == 500) {
     // 409
     Swal.fire({
      icon: 'error',
      title: 'เลขบัตรประชาชน ซ้ำ',
      showConfirmButton: false,
      timer: 1500,
     })
    } else if (error.response.data.statusCode == 413) {
     Swal.fire({
      icon: 'error',
      title: 'ไฟล์มีขนาดใหญ่เกินไป',
      text: 'กรุณาลองใหม่อีกครั้ง',
      showConfirmButton: false,
      timer: 1500,
     })
    }
   })
 },

 async setInsertUserJuristic({ commit }, payload) {
  console.log('setInsertUserJuristic test payload ', payload)

  const formData = new FormData()
  formData.append('title', payload.title)
  formData.append('firstName', payload.firstName)
  formData.append('lastName', payload.lastName)
  formData.append('cardNumber', payload.cardNumber)
  formData.append('houseCodeNumber', payload.houseCodeNumber)
  formData.append('registrationOffice', payload.registrationOffice)
  formData.append('buildingName', payload.buildingName)
  formData.append('address', payload.address)
  formData.append('floor', payload.floor)
  formData.append('villageNumber', payload.villageNumber)
  formData.append('lane', payload.lane)
  formData.append('road', payload.road)
  formData.append('province', payload.province)
  formData.append('district', payload.district)
  formData.append('subDistrict', payload.subDistrict)
  formData.append('postalCode', payload.postalCode)
  formData.append('phoneNumber', payload.phoneNumber)
  formData.append('email', payload.email)
  formData.append('username', payload.username)
  formData.append('password', '12345678')
  formData.append('confirmPassword', '12345678')
  formData.append('personType', payload.personType)
  formData.append('certificateOperateName', payload.certificateOperateName)
  formData.append(
   'certificateJuristicNumber',
   payload.certificateJuristicNumber
  )
  formData.append(
   'certificateEstablishmentName',
   payload.certificateEstablishmentName
  )
  formData.append('certificateLane', payload.certificateLane)
  formData.append('certificateVillageNumber', payload.certificateVillageNumber)
  formData.append('certificateRoad', payload.certificateRoad)
  formData.append('certificateProvince', payload.certificateProvince)
  formData.append('certificateDistrict', payload.certificateDistrict)
  formData.append('certificateSubDistrict', payload.certificateSubDistrict)
  formData.append('certificatePostalCode', payload.certificatePostalCode)
  formData.append('certificatePhoneNumber', payload.certificatePhoneNumber)
  formData.append('certificateEmail', payload.certificateEmail)
  formData.append('files', payload.partnershipsImageFiles)

  for (const certificateImageFile of payload.certificateImageFiles) {
   formData.append('files', certificateImageFile)
  }
  console.log('files ', formData.getAll('files'))

  const config = {
   headers: {
    'content-type': 'multipart/form-data',
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  await axios
   .post(`${ENDPOINT.CREATE_USER_JURISTIC}`, formData, config)
   .then(async (res) => {
    console.log('this is response :', res.data)
    if (payload.logoImageFiles) {
     await this.dispatch('users/addCompanySeal', {
      files: payload.logoImageFiles,
      userId: res.data.id,
     })
    }
    commit('SET_STATUS', 201)

    Swal.fire({
     target: document.getElementById('popup-notify'),
     icon: 'success',
     title: 'บันทึกข้อมูลสำเร็จ',
     showConfirmButton: false,
     timer: 1500,
    }).then(() => {
     window.location.href = '/admin/users'
    })
   })
   .catch((error) => {
    console.log(error)
    if (error.response.data.statusCode == 500) {
     // 409
     Swal.fire({
      icon: 'error',
      title: 'เลขบัตรประชาชน ซ้ำ',
      showConfirmButton: false,
      timer: 1500,
     })
    } else if (error.response.data.statusCode == 413) {
     Swal.fire({
      icon: 'error',
      title: 'ไฟล์มีขนาดใหญ่เกินไป',
      text: 'กรุณาลองใหม่อีกครั้ง',
      showConfirmButton: false,
      timer: 1500,
     })
    }
   })
 },
 addCompanySeal({ commit }, payload) {
  console.log('addCompanySeal ', payload)
  const formData = new FormData()
  formData.append('files', payload.files)
  formData.append('userId', payload.userId)
  const config = {
   headers: {
    'content-type': 'multipart/form-data',
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }
  axios.post(`${ENDPOINT.CREATE_COMPANY_SEAL}`, formData, config)
 },
 async validateSignatureUser({ commit }, payload) {
  const sigantureForm = new FormData()
  sigantureForm.append('files', payload.signature)
  sigantureForm.append('userId', payload.userId)

  const config = {
   headers: {
    'content-type': 'multipart/form-data',
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }

  const url = ENDPOINT.CREATE_SIGNATURE_USER

  await axios
   .post(url, sigantureForm, config)
   .then(async (response) => {
    commit('ERROR', null)
    commit('SET_SIGNATUR_NAME', response.data.signatureName)
   })
   .catch((error) => {
    commit('ERROR', error.response.data.statusCode)
    console.log(error)
   })
 },
 async setUpdateStatus({ commit }, id) {
  const config = {
   headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
   },
  }

  const url = `${ENDPOINT.UPDATE_USER_STATUS}/${id}`

  await axios
   .put(url, null, config)
   .then((res) => {
    console.log(res)
   })
   .catch((error) => {
    console.log(error)
   })
 },
 async getTeam({ commit }) {
  const url = ENDPOINT.GET_TEAM
  await axios
   .get(url, null, configWithToken)
   .then((response) => {
    commit('SET_TEAMS', response.data)
   })
   .catch((error) => {
    console.log(error)
   })
 },
}

export default {
 namespaced: true,
 state,
 mutations,
 actions,
}
